import * as React from 'react';
import {RouteChildrenProps} from 'react-router-dom';
import path from 'lodash/fp/path';
import {FieldInput} from '@practicegenius/pg-ui/src/base/Material/components/FieldInput';
import {FormScreen} from '../../../components/screens/FormScreen';
import {EmailInput} from '../../../shared/Material/components/EmailFieldInput';
import {bottomText} from '../layout';
import {forgotUsername} from '../../../http/login';
import {routes} from '../routes';
import {isEmail} from '../../../utils/string';
import {LoginSupportFooter} from '../../../components/LoginSupportFooter';

export class ForgotUsername extends React.Component<
  RouteChildrenProps & {
    submit: (a: any) => Promise<unknown>;
  }
> {
  static defaultProps = {
    submit: forgotUsername,
  };

  loginCredential = path(['location', 'state', 'login'], this.props);

  onSubmit = async (data: {email: string}) => {
    await this.props.submit(data);
    this.props.history.push(routes.login.forgotUsernameEmailSent, data);
  };

  render() {
    return (
      <FormScreen
        helmetTitle="Forgot Username"
        submit={this.onSubmit}
        submitText="Send"
        initialValues={{
          email: isEmail(this.loginCredential) ? this.loginCredential : '',
        }}
        headerTitle="Forgot Username"
        title="Let's get you into your Account"
        instructions="Enter the email address you used to register. We will send you an email with your username."
        bottomText={
          <>
            {bottomText('username')}
            <LoginSupportFooter />
          </>
        }
      >
        <FieldInput
          name="email"
          label="Email Address"
          component={EmailInput}
          autoFocus
        />
      </FormScreen>
    );
  }
}
